import BarcodesTab from './BarcodesTab'

export default BarcodesTab
